import { BaseViewModel } from 'src/app/common/viewmodel/base-view-model';

import { IMedicalOrder, IMedicalOrderRequest, ITransmittable } from '@alberta/konexi-shared';
import { MedicalOrderType } from '@alberta/konexi-shared/dist/general/enum/medicalOrderType';

export class MedicalOrderRequestViewModel extends BaseViewModel implements IMedicalOrderRequest {
  patientId: string;
  regionId: string;
  serviceOrderId: string;
  templateId: string;
  correspondenceType: ITransmittable['correspondenceType'];
  reminderLevel?: number;
  to: string;
  doctor: { name: string; additionalName: string; address: string; postalCode: string; city: string };
  patient: {
    customerNumber: string;
    name: string;
    additionalName: string;
    address: string;
    postalCode: string;
    city: string;
    birthday: string;
  };
  payer: { name: string; numberOfInsured: string };
  bodyTexts: string[];
  medicalOrders: IMedicalOrder[];
  additionalProperties: any;
  status: ITransmittable['status'];
  retry: number;
  faxProvider: string;
  faxProviderId: string;
  lastError: string;
  mimeType: string;
  fileUrl: string;
  medicalOrderType: MedicalOrderType;
  fileName: string;
  subject: string;
  body: string;
  history: { status: string; lastError?: string; retry?: number; timestamp: Date }[];
  diagnose: string;
  startDate: string;
  endDate: string;
  replyTo: string;
}
